import React, { Component, Fragment } from 'react';
import TicketContainer from '../../individualPortal/ticket/TicketContainer';

export default class BrokerTicketListContainer extends Component {

    render() {
        return(
            <Fragment>
                <TicketContainer />
            </Fragment>
        );
    }
}
